import React, { Component} from 'react';
import './TextComponent.css';

class TextComponent extends Component {
    render() {
        return(
            <article>
                <h6 className="mb-3">Вітаємо!</h6>
                <section>
                    <p className="font-weight-bold mb-0">Особистий кабінет дозволяє:</p>
                    <ul>
                        <li>отримати інформацію про свій Договір цільової програми;</li>
                        <li>стежити за своєю кар'єрою та кар'єрою своєї структури;</li>
                        <li>контролювати дані про нарахування та виплати;</li>
                        <li>розпоряджатися особистими коштами;</li>
                        <li>вносити чергові внески за договором у режимі онлайн;</li>
                        <li>переглядати та змінювати контактні дані;</li>
                        <li>отримувати новини та розсилки від страхової компанії та брокера;</li>
                    </ul>
                    <p className="bottomParagraph mb-0"
                    >
                        Доступ до Особистого кабінету надається кожному фінансовому консультанту, а також клієнту, який уклав Договір за цільовою програмою
                        <span> ⟪</span>Profi +<span>⟫</span>.
                    </p>
                </section>
            </article>
        )
    }
}
export default TextComponent;


// WEBPACK FOOTER //
// ./src/Login/TextComponent/TextComponent.js